import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postPlanoDeTrabalho = async (
  token: string,
  edital_id: number | undefined,
  instituicao_id: number,
  titulo_projeto: string,
  modalidade: string,
  orgao_financiador: string,
  objeto_parceria: string,
  area_atendimento: string,
  inicio: string,
  fim: string,
  descricao_realidade: string,
  forma_execucao: string,
  descricao_metas: string,
  indicadores: string,
  manutencao_equipamentos: string
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(
    `${API_URL}/planos-de-trabalho`,
    {
      titulo_projeto,
      modalidade,
      orgao_financiador,
      objeto_parceria,
      area_atendimento,
      inicio,
      fim,
      descricao_realidade,
      forma_execucao,
      descricao_metas,
      indicadores,
      manutencao_equipamentos,
      edital_id,
      instituicao_id,
    },
    config
  );
  return response.data;
};
export default postPlanoDeTrabalho;
